export default {
  template: 'default',
  isSystemDefault: false,
  name: 'models.invoice.sales',
  type: 'invoice',
  columns: ['index', 'description', 'date', 'quantity', 'unit', 'unitPrice', 'vatPct', 'total'],
  paymentMethods: [],
  fields: [
    { default: 'GBP', name: 'currency', visible: true },
    { default: '', name: 'description', visible: true },
    { name: 'dueDate', visible: true },
    { name: 'recipientReference', visible: false },
    { name: 'senderReference', visible: false },
    { default: 'description,date,quantity,unitPrice,vatPct,total', name: 'columns', visible: true },
    { default: 'false', name: 'discountEnabled', visible: false },
    { default: 'perTotal', name: 'discountLocation', visible: false },
    { default: 'amount', name: 'discountType', visible: false },
    { default: 'postVAT', name: 'discountVAT', visible: false },
    { name: 'interest', visible: false, default: '0.085' },
    { name: 'language', visible: true, default: 'en' },
    { name: 'paymentTime', visible: true, default: '30' },
    { name: 'referenceNumber', visible: false },
    { default: 'default', name: 'template', visible: false },
    { name: 'title', visible: true, default: 'INVOICE' },
    { default: '1', name: 'type', visible: true },
    { default: 'false', name: 'paymentScheduleEnabled', visible: true },
    { default: 'sameInvoice', name: 'paymentScheduleType', visible: false },
    { default: '1', name: 'numberOfPayments', visible: false },
    { default: 'monthly', name: 'customPaymentSchedulePeriod', visible: false },
    { default: 'onePerPayment', name: 'numberOfInvoices', visible: false },
    { default: '', name: 'customPaymentScheduleName', visible: false },
    { default: '', name: 'legalterms', visible: false },
    { default: '', name: 'footerText', visible: true }]
};
